<template>
    <div :class="['editable-cell', background ? 'bg' : 'none']">
      <div v-if="editable" style="position: relative;" class="editable-cell-input-wrapper">
        <a-input-number style="width: 100%" :step="step" :autoFocus="true" :max="max" class="text" :min="min" size="small" v-model="val" @blur="blur" @pressEnter="e => e.target.blur()" :precision="len" />
      </div>
      <div class="editable-cell-text-wrapper" :class="[color]" @click="edit" v-else>
        <a-spin :spinning="loading" size="small" class="spinning-block">
          <span :class="color" >
            {{ text|numberFixed(len)}} 
          </span>
        </a-spin>
      </div>
    </div>
</template>

<script>
export default {
  props:['text','item', 'name', 'actions','background','len','attMax','attMin'],
  data(){
    return {
      val:undefined,
      target:null,
      editable:false,
      loading:false,
      isBlue:false,
      isEdit: false
    }
  },
  computed:{
    color(){
      const {item,name} = this
      let red = name === 'maxValue' && (item.maxValue && item.xxx > item.maxValue) ? 'red' : false
      let green = name === 'minValue' && (item.minValue && item.xxx < item.minValue) ? 'green' : false
      return {
        red,green
      }
    },

    min(){
      return this.attMin || this.attMin === 0 ? this.attMin : this.name === 'price' ? 0 : -999999999
    },
    max(){
      return this.attMax || this.attMax === 0 ? this.attMax : this.name === 'price' ? 999999999999.999 : 999999999
    },

    defaultText(){
      const textValue = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(this.len || 3)
      return textValue
    },
    step(){
      const num = [1,0.1,0.01,0.001,0.0001]
      return num[this.len]
    },
    unit(){
      return this.len
    },
    warningIcon(){
      let flag = false
      if(this.name == 'minValue' || this.name == 'maxValue') {
        if((this.item.minValue || this.item.minValue === 0) && (this.item.maxValue || this.item.maxValue === 0) && (Number(this.item.minValue) > Number(this.item.maxValue))){
          flag = true
        }
      }
      return flag
    },
  },
  mounted(){},
  methods:{
    blur(e){
      this.editable = false
      let target = {...this.item}
      let val = e.target.value
      if(this.text === val || (this.text === Number(val) && val !== '') || (this.text === null && val === '')) return
      if(this.checkValue(this.val)){
        if(this.val < 0 && this.name === 'price'){
          this.$message.warn('价格不能为负数')
        }
        this.isBlue=true
        target[this.name] = this.val ? this.val.toFixed(this.len || 3) : this.val
        this.target = target
        this.$nextTick(()=>{
          this.updates()
        })
      }
    },
    checkValue(val){
      const {name,item} = this
      if(val === null){
        return true
      } else if((name==="minLimitValue" && val > item.maxLimitValue && (item.maxLimitValue || item.maxLimitValue === 0))
      || (name==="maxLimitValue" && item.minLimitValue > val) 
      || (name==="maxValue" && item.minValue > val) 
      || (name==="minValue" && val > item.maxValue && (item.maxValue || item.maxValue === 0))) {
        // this.errorMessage()
        return true
      } else {
        return true
      }
    },
    async updates(){
      this.$nextTick(async() => {
        if(this.actions){
          this.$emit('blur',this.target)
          this.loading = true
          await this.actions(this.target,true,this.name)
          this.loading = false
        } else {
          this.loading = false
          this.$emit('blur',this.target)
        }
      })
    },
    change(val){
      this.val = val
    },
    edit(){
      this.editable = true
        this.isEdit = true
      this.val = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(this.len || 3)
    },
    errorMessage(){
      const msg = this.name ==='minLimitValue' || this.name === 'maxLimitValue' ? '极下限不能大于极上限' :'最小值不能大于最大值'
      this.$message.warn(msg)
    }
  }
  }
</script>

